import { detect, Browser } from "detect-browser";

// const may_not_work = `
// お使いのブラウザでの動作は確認されていません。
// 動作の確認が取れているブラウザは以下です。

// Mac:
//   Safari, Firefox, Google Chrome
// Windows:
//   Microsoft Edge, Firefox, Google Chrome

// このブラウザで続けますか？
// `

const should_not_work = `
お使いのブラウザではGALAXY CRUISEは動作しません。
動作の確認が取れているブラウザは以下です。

Mac:
  Safari, Firefox, Google Chrome
Windows:
  Microsoft Edge, Firefox, Google Chrome

これらのブラウザからアクセスしてくださいます様お願い致します。
`

export function browserCheck() {
  const browser = detect()
  if (browser && browser.name === 'ie') {
    alert(should_not_work)
    location.href = '..'
  }
}
